import ProberEvent from './ProberEvent'
import {PROBER_EVENT_CUSTOM} from './ProberEventTypes'

export default class CustomEvent extends ProberEvent {
  constructor(data: any = {}) {
    super(data)
    this.data.type = PROBER_EVENT_CUSTOM
  }
}
